import { Button, Grid } from '@material-ui/core'
import { Stack } from '@mui/material'
import CustomTextField from 'components/Form/CustomTextField'
import ProgressButton from 'components/ProgressButton'
import { Form, Formik } from 'formik'
import React from 'react'
import { TemplateFormSchema } from 'schemas/setting'
import TipTapEditor from 'components/TipTapEditor/TipTapEditor'
import {
  emailTemplatePlaceholderItems,
  welcomeEmailTemplatePlaceholderItems,
  exportLeadsPlaceholderItems
} from 'components/TipTapEditor/placeholders'
import ErrorMessage from 'components/ErrorMessage'

export const TemplateForm = ({ onCancel, onSubmit, isLoading, initialValues, templateId }) => {
  // Determine which placeholders to use based on template type
  const getPlaceholders = () => {
    if (templateId === 'welcomeEmail') {
      return { hasPlaceholders: true, placeholders: welcomeEmailTemplatePlaceholderItems }
    }
    if (templateId === 'exportLeadsEmail') {
      return { hasPlaceholders: true, placeholders: exportLeadsPlaceholderItems }
    }
    // Default to email template placeholders for all other email templates
    return { hasPlaceholders: true, placeholders: emailTemplatePlaceholderItems }
  }

  const { hasPlaceholders, placeholders } = getPlaceholders()
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={TemplateFormSchema}>
      {({ setFieldValue, values, errors, touched }) => (
        <Form>
          <Grid container item spacing={3}>
            <Grid item xs={12}>
              <CustomTextField label="Email Subject" name="subject" type="text" />
            </Grid>

            <Grid item xs={12}>
              <TipTapEditor
                value={values.body}
                onChange={(value) => setFieldValue('body', value)}
                placeholder="Write your email body here..."
                error={!!(touched?.body && errors?.body)}
                minHeight="200px"
                maxHeight="500px"
                hasPlaceholders={hasPlaceholders}
                placeholders={placeholders}
              />
              <ErrorMessage message={touched?.body && errors?.body} />
            </Grid>
          </Grid>

          <Stack direction="row" gap={2} justifyContent="end" mt={4} mb={1}>
            <Button onClick={onCancel} disabled={isLoading}>
              Cancel
            </Button>
            <Grid item>
              <ProgressButton
                type="submit"
                label="Save"
                variant="contained"
                color="primary"
                disabled={isLoading}
                inProgress={isLoading}
              />
            </Grid>
          </Stack>
        </Form>
      )}
    </Formik>
  )
}

export default TemplateForm
